import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_CANCEL_SUBSCRIPTION_BY_COACH_BEGIN,
  USER_CANCEL_SUBSCRIPTION_BY_COACH_SUCCESS,
  USER_CANCEL_SUBSCRIPTION_BY_COACH_FAILURE,
  USER_CANCEL_SUBSCRIPTION_BY_COACH_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function cancelSubscriptionByCoach(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_CANCEL_SUBSCRIPTION_BY_COACH_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${config.apiRootUrl}/subscriptions/cancel-subscription-by-coach`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_CANCEL_SUBSCRIPTION_BY_COACH_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_CANCEL_SUBSCRIPTION_BY_COACH_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCancelSubscriptionByCoachError() {
  return {
    type: USER_CANCEL_SUBSCRIPTION_BY_COACH_DISMISS_ERROR,
  };
}

export function useCancelSubscriptionByCoach() {
  const dispatch = useDispatch();

  const { cancelSubscriptionByCoachPending, cancelSubscriptionByCoachError } =
    useSelector(
      (state) => ({
        cancelSubscriptionByCoachPending:
          state.user.cancelSubscriptionByCoachPending,
        cancelSubscriptionByCoachError:
          state.user.cancelSubscriptionByCoachError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(cancelSubscriptionByCoach(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCancelSubscriptionByCoachError());
  }, [dispatch]);

  return {
    cancelSubscriptionByCoach: boundAction,
    cancelSubscriptionByCoachPending,
    cancelSubscriptionByCoachError,
    dismissCancelSubscriptionByCoachError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_CANCEL_SUBSCRIPTION_BY_COACH_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        cancelSubscriptionByCoachPending: true,
        cancelSubscriptionByCoachError: null,
      };

    case USER_CANCEL_SUBSCRIPTION_BY_COACH_SUCCESS:
      // The request is success
      return {
        ...state,
        cancelSubscriptionByCoachPending: false,
        cancelSubscriptionByCoachError: null,
      };

    case USER_CANCEL_SUBSCRIPTION_BY_COACH_FAILURE:
      // The request is failed
      return {
        ...state,
        cancelSubscriptionByCoachPending: false,
        cancelSubscriptionByCoachError: action.data.error,
      };

    case USER_CANCEL_SUBSCRIPTION_BY_COACH_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        cancelSubscriptionByCoachError: null,
      };

    default:
      return state;
  }
}
